import React, { useState } from "react";
import "../../styles/NewsletterUnsubscribe.css";
import Api from "../../../../shared/api/api";

const NewsletterUnsubscribe = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await Api.unsubscribeNewsletter(email);
      setStatus({ type: "success", message: res.message });
    } catch (err) {
      setStatus({
        type: "error",
        message: err.response?.data?.error || "Unsubscribe failed.",
      });
    }
  };

  return (
    <div className="newsletter-unsubscribe">
      <h2>Unsubscribe from Newsletter</h2>
      <p>Enter your email address to stop receiving newsletters from Kenneth L Powell.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Unsubscribe</button>
      </form>
      {status && (
        <p className={status.type === "success" ? "success" : "error"}>
          {status.message}
        </p>
      )}
    </div>
  );
};

export default NewsletterUnsubscribe;
